import { useEffect } from "react";
import { minusOnePx, theme, useMedia } from "@catchoftheday/theme";
import { cookies } from "@catchoftheday/utilities";
export var useSetDeviceCookie = function useSetDeviceCookie() {
  var isMobile = useMedia(["(max-width: ".concat(minusOnePx(theme.breakpoints.md, true), ")")], [true]);
  useEffect(function () {
    cookies.set("isMobile", "".concat(!!isMobile));
  }, [isMobile]);
  return null;
};